export enum TrackingType {
    General = 'general',
    Travel = 'travel',
}
